import { V4 } from '@moleculeone/utils';

function doubleBondSide(drawnMol, drawnBond, cycle) {
  const startpos = drawnMol.atoms[drawnBond.start].pos;
  const endpos = drawnMol.atoms[drawnBond.end].pos;
  const center = V4.average.apply(
    null,
    cycle.map(idx => drawnMol.atoms[idx].pos)
  );
  const bondcenter = V4.average(startpos, endpos);

  const bondvector = V4.sub(startpos, endpos);
  const centervector = V4.sub(center, bondcenter);
  return V4.crossZ(bondvector, centervector) > 0 ? 'left' : 'right';
}

export function setBondLines(mol, drawnMol) {
  for (const [key, drawnBond] of Object.entries(drawnMol.bonds)) {
    const bond = mol.bonds[key];
    drawnBond.center = { type: bond.type };
    if (bond.order === 3) {
      drawnBond.left = {};
      drawnBond.right = {};
    }
    let side = 'right';
    if (bond.order === 2 && drawnBond.data.cycle) {
      side = doubleBondSide(drawnMol, drawnBond, drawnBond.data.cycle);
    }
    if (bond.order === 2) {
      drawnBond[side] = {};
    }
  }
}
